/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Patients from './Patients/index'
import React from 'react'
import SystemFiles from './SystemFiles/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Patients
  viewPath={`${viewPath}/Patients`}
/>
<SystemFiles
  viewPath={`${viewPath}/SystemFiles`}
/>
</div>
{children}
</React.Fragment>)
}